'use strict';

class TipSubmitter {
  constructor({ placeId, csrf }) {
    this.placeId = placeId;
    this.csrf = csrf;
    this.rootUrl = '/merchant-page';
  }

  submitTip(
    inputText,
    isMerchantSpecialTip,
    triggeredOnPageLoad = false,
    { success, fail }
  ) {
    const text = inputText.trim();
    const obj = {
      _csrf: this.csrf,
      placeId: this.placeId,
      text,
      triggeredOnPageLoad,
      isMerchantSpecialTip,
    };

    $.ajax({
      url: `${this.rootUrl}/tips/create`,
      method: 'POST',
      data: JSON.stringify(obj),
      contentType: 'application/json',

      success(res) {
        // Server always returns http success, but embeds actual errors in response
        if (res.result === 'ok') {
          success(res);
          return;
        }

        fail(res);
      },
    });
  }
}

Groupon.TipSubmitter = TipSubmitter;
